module.exports = __webpack_public_path__ + "img/vision_01.f96eccf2.jpg";